const axios = require('axios')
const config = require('../config')
const fs = require('fs')

let token

function handle(promise) {
	return new Promise((resolve, reject) => {
		promise.then((data) => {
			if (data.status != 200) {
				let string = data.statusText

				if (data.data.error) {
					string = `${string}, ${data.data.error}`
				}

				return reject(string, data)
			}

			if (data.data.status == "ERROR") {
				let err = data.data.error

				if (Array.isArray(err)) {
					err = err[0]

					if (typeof err === 'object' && err.msg) {
						err = `${err.msg} ${err.param}`
					}
				}

				return reject(err, data)
			}

			resolve(data.data)
		}).catch((err, d) => {
			console.error(err)
			reject(err)
		})
	})
}

export function setToken(t) {
	token = t
}

function formHeaders(params) {
	return {
		headers: { 
			'Authorization': `Bearer ${token}`
		},

		params: params
	}
}

export function post(route, options) {
	return handle(axios.post(config.apiUrl + route, options, formHeaders()))
}

export function get(route, options) {
	return handle(axios.get(config.apiUrl + route, formHeaders(options)))
}

export function download(route, name, callback) {
	handle(axios.get(config.apiUrl + route, {
		responseType: 'arraybuffer'
	}), (err, data) => {
		if (err) {
			return callback(err)
		}

		fs.writeFile(name, Buffer.from(data, 'binary'), 'binary', (err) =>	 {
			if (err) {
				return callback('Failed to save the file: ' + err)	
			}

			callback(null, {

			})
		})
	})
}

export function setupAuth(token) {
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export function removeAuth() {
	axios.defaults.headers.common['Authorization'] = null
}
